import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { endParty } from '../api/client.js';
import { partyViewQueryKey } from '../api/queryKeys.js';
import { noteEndedByMe } from '../lib/endedParty.js';

import { useMyPartyInvalidation } from './useMyPartyInvalidation.js';

import type { PartySlug, PartyView } from '@mixwire/contracts';

/** Ends the party for everyone, stopping every Spotify poll the server held for it. */
export const useEndParty = (): UseMutationResult<PartyView, Error, PartySlug> => {
  const queryClient = useQueryClient();
  const invalidateMyParty = useMyPartyInvalidation();

  return useMutation({
    mutationFn: endParty,
    onSuccess: (party) => {
      noteEndedByMe(party.slug);
      queryClient.setQueryData<PartyView>(partyViewQueryKey(party.slug), party);
      invalidateMyParty();
    },
  });
};
